var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 464,
    viewBox: "0 0 338 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 463.4C275.2 463.4 337.6 398 337.6 323.6C337.6 260.6 304.6 223.4 249.4 201.2L193.6 179C154 163.4 126.4 153.8 126.4 128.6C126.4 105.2 146.2 92 179.2 92C214 92 241.6 104 271 126.2L324.4 59C285.4 20 230.8 0.19999 179.2 0.19999C84.4 0.19999 17.2 60.2 17.2 135.2C17.2 200 61 239 107.8 257.6L164.8 281.6C203.2 297.8 227.8 306.2 227.8 332C227.8 356 209.2 371 169.6 371C134.2 371 92.8 352.4 61.6 325.4L0.4 399.2C46.6 441.8 109 463.4 167.2 463.4Z",
    fill: "#20B075",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSForm);
export default __webpack_public_path__ + "static/media/SForm.d8e20a2732b81a4e4ed2c5cd69e40d2a.svg";
export { ForwardRef as ReactComponent };